import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a3d5ae18")

_pushScopeId("data-v-a3d5ae18")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "カレンダー", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("週の開始曜日 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_radio_button_group = _resolveComponent("radio-button-group")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_radio_button_group, {
      "group-id": "start-day",
      radios: _ctx.startDayOptions,
      modelValue: _ctx.calendarStartDay,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.calendarStartDay = $event))
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["radios", "modelValue"])
  ]))
})